import { IInformationState, IInformationRequest } from './Information.types';

export enum ActionTypes {
    INFORMATION = 'INFORMATION',
    INFORMATION_REQUEST = 'INFORMATION_REQUEST',
    INFORMATION_SUCCEEDED = 'INFORMATION_SUCCEEDED',
    INFORMATION_FAILED = 'INFORMATION_FAILED',
    INFORMATION_SET_APIUPDATESTATE = 'INFORMATION_SET_APIUPDATESTATE'
}

export type IInformationActions =
    | IRequestInformationAction
    | IReceiveInformationAction
    | ISetInformationApiUpdateStateStateAction;

export interface IRequestInformationAction {
    type: ActionTypes.INFORMATION_REQUEST;
    data?: IInformationRequest;
}

export interface IReceiveInformationAction {
    type: ActionTypes.INFORMATION_SUCCEEDED | ActionTypes.INFORMATION_FAILED;
    data: IInformationState;
    errorMsg: string;
}

export interface ISetInformationApiUpdateStateStateAction {
    type: ActionTypes.INFORMATION_SET_APIUPDATESTATE;
    data: boolean;
}
